import './App.css';

import { Outlet } from 'react-router';
import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';
import NotificationsContainer from '@rio-cloud/rio-uikit/NotificationsContainer';

import { useAppDispatch, useAppSelector } from '../../configuration/setup/hooks';
import { getDisplayMessages, getLocale } from '../../configuration/lang/langSlice';

import AppHeader from './header/AppHeader';
import { getSessionExpiredAcknowledged, hideSessionExpiredDialog } from './appSlice.ts';
import { isUserSessionExpired } from '../../configuration/login/loginSlice.ts';
import { SessionExpiredDialog } from '@rio-cloud/rio-session-expired-info';
import { AssetSidebar } from './assets/sidebar/AssetSidebar.tsx';
import RouteListener from './routes/RouteListener.tsx';

const App = () => {
    const userLocale = useAppSelector(getLocale);
    const displayMessages = useAppSelector(getDisplayMessages);
    const showSessionExpired = useAppSelector(
        state => isUserSessionExpired(state) && !getSessionExpiredAcknowledged(state)
    );

    const dispatch = useAppDispatch();

    if (!displayMessages || !userLocale) {
        return null;
    }

    return (
        <ApplicationLayout className={'StarterTemplate'}>
            <ApplicationLayout.Header>
                <AppHeader />
            </ApplicationLayout.Header>
            <ApplicationLayout.Sidebar className={'right'}>
                <AssetSidebar />
            </ApplicationLayout.Sidebar>
            <ApplicationLayout.Body>
                <NotificationsContainer />
                <SessionExpiredDialog
                    locale={userLocale}
                    onClose={() => dispatch(hideSessionExpiredDialog())}
                    show={showSessionExpired}
                />
                <RouteListener />
                <Outlet />
            </ApplicationLayout.Body>
        </ApplicationLayout>
    );
};

export default App;
